








































































































































































































































































































































































    import {
        defineComponent,
        ref,
        computed,
        onMounted,
        watch,
    } from "@vue/composition-api";
    import { profile as profilestore } from "@/store/index";
    import { alarm, app } from "@/store";
    import parseISO from "date-fns/esm/fp/parseISO/index";
    import useLogbook from "@/store/useLogbook";
    import useMap from "@/utilities/useGoogleMaps";
    import { domToPng, domToBlob } from 'modern-screenshot'
    import useFavouriteJourney from "@/store/useFavouriteJourney";
    import FavouriteJourneyViewModel from "../models/FavouriteJourneyViewModel";
    import ProfileViewModel from "@/models/ProfileViewModel";
    import { deleteImageFromBlobStorage, downloadImageFromBlobStorage, uploadImageToBlobStorage, deleteImagesStartingWith } from "../store/useUserPictureStorage";
import { ca } from "date-fns/locale";

    export default defineComponent({
        name: "LogbookRecord",
        components: {
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue"),
            ShareDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/ShareDialog.vue"),
            LoadingDialog: () =>
                import(/* webpackChunkName: "settings" */ "./components/Dialogs/LoadingDialog.vue"),
        },

        setup(props, { root }) {
            // Constants
            const CANVAS_WIDTH = 1535;
            const START_HEIGHT = 320;
            const HORIZONTAL_GAP = 100;
            const VERTICAL_GAP = 50;
            const LARGE_VERTICAL_GAP = VERTICAL_GAP * 2;
            const BORDER_WIDTH = 5;
            const ELEMENT_COLOR = 'white';
            const IMAGE_FORMAT = 'image/jpeg';
            const SHARE_FILE_NAME = 'MarineOne.jpg';
            const LOGO_IMAGE_PATH = '/img/logo.png';
            const BACKGROUND_IMAGE_PATH = 'img/background_long.jpg';
            const TITLE = "Captain's Log";

            const profile = computed<ProfileViewModel>(() => {
                return profilestore.profile;
            });

            const { getFavouriteJourney, updateFavouriteJourney, saveFavouriteJourney, deleteFavouriteJourney } = useFavouriteJourney();

            const hasGalleryAccess = computed<boolean>(() => {
                return profile.value ? profile.value.hasGalleryAccess : false;
            });

            const isCaptain = computed<boolean>(() => {
                return profile.value ? profile.value.isCaptain : false;
            });

            // Get the selected date from the route parameters.
            const selectedDate = root.$route.params.date;

            const journeyId = root.$route.params.journeyId;

            // Get the logbook item from the route parameters.
            const isFavourite = computed(() => {
                return root.$route.params.isFavourite;
            });

            const journey = ref(new FavouriteJourneyViewModel());

            const { googleMapApi } = useMap();
            const map = ref();
            let myGoogleMap: google.maps.Map;
            let poly: google.maps.Polyline;
            let shipMarker: google.maps.Marker;
            let startMarker: google.maps.Marker;
            let endMarker: google.maps.Marker;
            let ship: google.maps.LatLng;
            let startIcon: google.maps.Icon;
            let endIcon: google.maps.Icon;
            let roundTripIcon: google.maps.Icon;
            let maxSpeedIcon: google.maps.Icon;
            let historyIcon: google.maps.Symbol;
            let onMountedFinished = false;
            let logbookItemsFetched = false;
            const showCarousel = ref(false);
            const totalTime = ref("");
            const startTime = ref("");
            const stopTime = ref("");
            const totalDistance = ref("");
            const averageSpeed = ref("");
            const roundTripRadius = 10; // 10 meters radius determining if the trip is a round trip or not.
            const maxSpeed = ref("");
            let maxSpeedIndex = 0;
            let carouselModel = ref(0);
            const showLoadingDialog = ref(false);
            const showEditNicknameDialog = ref(false);
            const showSaveDialog = ref(false);
            const showDeleteDialog = ref(false);
            const showShareDialog = ref(false);
            const infoWindows = [];
            const showHint = ref(false);
            const showExtras = ref(false);
            const nickname = ref("");
            const description = ref("");
            let file: File;
            const uploadFile = ref<File | null>(null);
            let logFileName: string;
            const shareImageUrl = ref("");

            const goToGallery = async () => {
                logFileName = generateRandomFileName();
                // Wait for captureLog to complete
                try {
                    await captureLog();

                    if (uploadFile && uploadFile.value) {
                        await deleteImagesStartingWith("temp_" + profile.value.userId);
                        await uploadImageToBlobStorage(logFileName, new Uint8Array(await uploadFile.value.arrayBuffer()));
                    } else {
                        console.error("uploadFile or uploadFile.value is null");
                    }
                } catch (error) {
                    console.error("An error occurred:", error);
                }
                showLoadingDialog.value = false;
                root.$router.push({ name: "userGallery", params: { id: journeyId, deviceId: profile.value.deviceId, logFile: logFileName } });
            };

            const saveJourney = () => {

                let model = new FavouriteJourneyViewModel();
                model.favouriteDate = selectedDate;
                model.nickname = nickname.value;
                model.description = description.value;
                journey.value = model;
                saveFavouriteJourney(model);
                showExtras.value = false;
                showSaveDialog.value = false;
                app.success = "Journey saved successfully";
            };

            const updateJourney = () => {
                updateFavouriteJourney(journey.value);
                showExtras.value = false;
                showEditNicknameDialog.value = false;
            };

            const deleteJourney = async () => {

                const filenames = [journey.value.image1, journey.value.image2, journey.value.image3, journey.value.image4, journey.value.image5]

                for (let filename of filenames) {
                    if (filename) {
                        console.log("LogbookRecord: deleteJourney: deleting filename: " + filename);
                        await deleteImageFromBlobStorage(filename);
                    }
                }
                deleteFavouriteJourney(parseInt(journeyId));
                showExtras.value = false;
                showDeleteDialog.value = false;
                app.success = "Journey removed from favourites successfully";
                root.$router.push({ name: "settings" });
            };

            const captureLog = (): Promise<void> => {
                return new Promise((resolve, reject) => {
                    // user intent is clear, start conversion process
                    showLoadingDialog.value = true;

                    domToBlob(document.querySelector('#logContainer'), { type: 'image/jpeg', scale: 5 })
                        .then(blob => {
                            // Create an Image object from the blob
                            const img = new Image();
                            const crop = 570; // 300 pixels to crop from top bar and 270 pixels to crop from the map to hide logo and map/satellite options
                            img.onload = () => {
                                // Create a canvas to draw the cropped image
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                canvas.width = img.width;
                                canvas.height = img.height - crop;

                                // Draw the image starting after the crop
                                ctx.drawImage(img, 0, - crop);

                                // Convert the canvas back to a blob
                                canvas.toBlob(croppedBlob => {
                                    uploadFile.value = new File([croppedBlob], logFileName, { type: 'image/jpeg' });
                                    resolve(); // Signal that the uploadFile.value is set
                                }, 'image/jpeg');
                            };

                            img.src = URL.createObjectURL(blob);
                        })
                        .catch(error => {
                            reject(error); // handle the error
                        });
                });
            };

            // Helper function to load an image
            const loadImage = (src: string): Promise<HTMLImageElement> => {
                return new Promise<HTMLImageElement>((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = src;
                });
            };

            // Helper function to download and prepare images
            const downloadAndPrepareImages = async (filenames) => {
                const imageList = [];
                for (let filename of filenames) {
                    if (filename) {
                        const imageData = await downloadImageFromBlobStorage(filename);
                        const blob = new Blob([imageData], { type: IMAGE_FORMAT });
                        const url = URL.createObjectURL(blob);
                        const img = await loadImage(url);
                        imageList.push(img);
                    }
                }
                return imageList;
            };

            // Helper function to calculate the total height of the canvas
            const calculateTotalHeight = (logImage: HTMLImageElement, imageList?: HTMLImageElement[]): number => {
                let totalHeight = 0;

                // Add the starting height
                totalHeight += START_HEIGHT;

                // Calculate logImage height
                const logHeight = (CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                totalHeight += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;

                if (imageList) {
                    // Calculate height for each image in the list if included
                    for (let image of imageList) {
                        const scaledWidth = CANVAS_WIDTH - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);
                        const scaledHeight = scaledWidth * image.height / image.width;
                        totalHeight += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                    }
                }

                // Add a LARGE_VERTICAL_GAP after last image and subtract overflow (calculated manually)
                totalHeight += LARGE_VERTICAL_GAP - 32;

                return totalHeight;
            };

            const captureAndShareBase = async (includeGallery = false) => {
                try {
                    showLoadingDialog.value = true;

                    await captureLog();
                    
                    const logoImg: HTMLImageElement = await loadImage(LOGO_IMAGE_PATH);
                    const background: HTMLImageElement = await loadImage(BACKGROUND_IMAGE_PATH);
                    const logImage: HTMLImageElement = new Image();

                    if (uploadFile && uploadFile.value) {
                        const logUrl = URL.createObjectURL(uploadFile.value);
                        logImage.src = logUrl;
                        await new Promise(resolve => logImage.onload = resolve);

                        // Load the gallery images if required
                        let imageList: HTMLImageElement[] = [];

                        if (includeGallery) {
                            // Fetch journey images
                            const filenames = [
                                journey.value.image1,
                                journey.value.image2,
                                journey.value.image3,
                                journey.value.image4,
                                journey.value.image5
                            ];

                            if (filenames.length > 0) {
                                imageList = await downloadAndPrepareImages(filenames);
                            }
                        }

                            // Create canvas and its context
                            const canvas = document.createElement('canvas');
                            canvas.width = CANVAS_WIDTH;
                        canvas.height = calculateTotalHeight(logImage, imageList);
                            const ctx = canvas.getContext('2d');

                            // Draw the background
                            ctx.drawImage(background, 0, 0, CANVAS_WIDTH, canvas.height);

                            // Draw the logo
                            ctx.drawImage(logoImg, HORIZONTAL_GAP, VERTICAL_GAP, logoImg.width / 2, logoImg.height / 2);

                            // The position where the logo starts vertically (top-most point)
                            const logoStartY = VERTICAL_GAP;

                            // The height of the logo after scaling
                            const scaledLogoHeight = (logoImg.width / 2) * logoImg.height / logoImg.width;

                            // Calculate mid-points for title and date relative to the logo's vertical position
                            const titleMidPoint = logoStartY + (scaledLogoHeight / 2);  // Half of the upper half
                            const dateMidPoint = logoStartY + scaledLogoHeight - 32;  // Half of the lower half

                            // Draw the title
                            ctx.font = "78px Arial"; // change to Open sans
                            ctx.fillStyle = ELEMENT_COLOR;
                            ctx.textAlign = "center";
                            const titleX = (canvas.width / 2) + (canvas.width / 5);
                            ctx.fillText(TITLE, titleX, titleMidPoint);

                            // Draw the date
                            const date = formattedDate.value;
                        ctx.font = "55px Arial";
                            ctx.fillStyle = ELEMENT_COLOR;
                            const dateX = (canvas.width / 2) + (canvas.width / 5);
                            ctx.fillText(date, dateX, dateMidPoint);

                            // Starting Y position for journey images
                        let currentY = logoStartY + scaledLogoHeight + VERTICAL_GAP;


                        // Draw log
                        const logHeight = (canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH)) * logImage.height / logImage.width;
                        const logWidth = canvas.width - 2 * (HORIZONTAL_GAP + BORDER_WIDTH);

                        // Create the white border
                        ctx.fillStyle = ELEMENT_COLOR;
                        ctx.fillRect(
                            HORIZONTAL_GAP - BORDER_WIDTH,
                            currentY - BORDER_WIDTH,
                            logWidth + 2 * BORDER_WIDTH,
                            logHeight + 2 * BORDER_WIDTH
                        );

                        // Draw the log image inside the white border
                        ctx.drawImage(logImage, HORIZONTAL_GAP, currentY, logWidth, logHeight);

                        // Adjust currentY for subsequent images
                        currentY += logHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;

                        // Optionally draw the gallery images
                        if (includeGallery && imageList.length > 0) {

                            for (let image of imageList) {
                                const scaledWidth = canvas.width - 2 * HORIZONTAL_GAP;
                                const scaledHeight = scaledWidth * image.height / image.width;

                                // Draw the white border/background
                                ctx.fillStyle = ELEMENT_COLOR;
                                ctx.fillRect(HORIZONTAL_GAP - BORDER_WIDTH, currentY - BORDER_WIDTH, scaledWidth + 2 * BORDER_WIDTH, scaledHeight + 2 * BORDER_WIDTH);

                                // Draw the image on top of the white background
                                ctx.drawImage(image, HORIZONTAL_GAP, currentY, scaledWidth, scaledHeight);

                                // Move to the position for the next image
                                currentY += scaledHeight + 2 * BORDER_WIDTH + VERTICAL_GAP;
                            }

                        }
                        // Handle the final image
                        canvas.toBlob(croppedBlob => {
                            file = new File([croppedBlob], SHARE_FILE_NAME, { type: IMAGE_FORMAT });
                            showLoadingDialog.value = false;
                            shareImageUrl.value = URL.createObjectURL(file);
                            showShareDialog.value = true;
                            URL.revokeObjectURL(logUrl);
                        }, IMAGE_FORMAT);

                        // Hide loading dialog
                        showLoadingDialog.value = false;

                    } else {
                        app.error = "Image creation failed";
                        showLoadingDialog.value = false;
                    }

                } catch (err) {
                    showLoadingDialog.value = false;
                    app.error = "An error occurred while generating the image: " + err;
                    console.error("An error occurred:", err);
                }
            };

            const shareNow = () => {
                // only display the loading dialog if sharing is possible
                if ((navigator as any).canShare && (navigator as any).canShare({ files: [file] })) {

                    const shareData: any = {
                        files: [file],
                        title: 'MarineOne Logbook',
                        text: 'MarineOne logbook entry from ' + formattedDate.value,
                    };

                    (navigator as any).share(shareData)
                        .then(() => {
                            console.log('Sharing successful.');
                        })
                        .catch((error: any) => {
                            app.error = error;
                        });
                } else {
                    app.error = `Your device doesn't support sharing files.`;
                }
            }

            const getIconPath = (icon) => {
                return require(`@/assets/icons/${icon}.svg`);
            };

            const tripData = ref([
                { label: 'Start Time', value: '00:00', unit: '', icon: 'timer-play-outline' },
                { label: 'Stop Time', value: '00:00', unit: '', icon: 'timer-stop-outline' },
                { label: 'Trip Time', value: '0s', unit: '', icon: 'timer-sync-outline' },
                { label: 'Trip Distance', value: '0.00', unit: 'NM', icon: 'map-marker-distance' },
                { label: 'Average Speed', value: '0.00', unit: 'kts', icon: 'speedometer-medium' },
                { label: 'Max Speed', value: '0.00', unit: 'kts', icon: 'speedometer' }
            ]);

            const menuItems = ref([
                { icon: 'mdi-share-variant-outline', text: 'Share Trip', value: 'share' },
                { icon: 'mdi-check', text: 'Show All Trip Info', value: 'show-all' },
            ]);

            const hintItems = ref([
                { icon: 'view-carousel-outline-blk', text: 'Cycle trip info', subtext: '' },
                { icon: 'view-sequential-blk', text: 'View all trip info' },
                { icon: 'share-variant-outline-blk', text: 'Share trip as a screenshot' },
                { icon: 'compass', text: 'North indicator' },
                { icon: 'map-position-dot', text: 'Position dot', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-arrow', text: 'Boat heading indicator', subtext: 'Click: Info bubble with heading' },
                { icon: 'map-marker-round-trip', text: 'Round trip indicator', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-marker-start', text: 'Start trip location', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'map-marker-stop', text: 'Finish trip location', subtext: 'Click: Info bubble with time and GPS' },
                { icon: 'max-speed', text: 'Section with maximum speed', subtext: 'Click: Info bubble with max speed' },
                { icon: 'info-circle-blk', text: 'Click map anywhere to close bubbles' },
            ]);

            // Create a return function to go back to the settings page.
            const goBack = () => {
                root.$router.push({ name: "settings" });
            };

            // Create a latitude and longitude object from the alarm's latitude and longitude values.
            const lat = computed<number>(() => { return alarm.lat ? alarm.lat : 0; });
            const lng = computed<number>(() => { return alarm.lng ? alarm.lng : 0; });

            const formattedDate = computed<string>(() => {
                const date = new Date(selectedDate);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();

                let daySuffix = 'th';
                if (day === 1 || day === 21 || day === 31) {
                    daySuffix = 'st';
                } else if (day === 2 || day === 22) {
                    daySuffix = 'nd';
                } else if (day === 3 || day === 23) {
                    daySuffix = 'rd';
                }

                return `${day}${daySuffix} of ${month}, ${year}`;
            });

            // Create a start date and end date for the selected date.
            const startDate = computed(() => {
                const currentDate = parseISO(selectedDate);
                return new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
                ).toISOString().substring(0, 10);
            });

            const endDate = computed(() => {
                const startDateValue = new Date(startDate.value);
                const endDateValue = new Date(startDateValue.getTime() + 1 * 24 * 60 * 60 * 1000);
                return endDateValue.toISOString().substring(0, 10);
            });

            // Create a date range for the selected date.
            const selectedDateRange = computed<string>(() => {
                return startDate.value + "," + endDate.value;
            });

            // Get the logbook items for the selected date range.
            const { logbookItems } = useLogbook(selectedDateRange.value);

            // Function to determine if marker2 is within the given radius of marker1
            function isMarkerWithinRadius(marker1: google.maps.Marker, marker2: google.maps.Marker, radius: number): boolean {
                const position1 = marker1.getPosition();
                const position2 = marker2.getPosition();
                const distance = google.maps.geometry.spherical.computeDistanceBetween(position1, position2);
                return distance <= radius;
            }

            // Function to calculate the speed between two points given their latitude, longitude, and timestamps
            function calculateSpeedInKnots(point1: google.maps.LatLng, time1: number, point2: google.maps.LatLng, time2: number): number {

                const distance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2) / 1852; // Convert to nautical miles

                // Calculate the time difference in seconds
                const timeDiff = Math.abs(time2 - time1) / 1000;

                // Calculate the speed in knots
                let speed = distance / (timeDiff / 3600); // Convert to knots

                return speed;
            }

            // Function to find the maximum speed among sections of the polyline
            function findMaxSpeed(polyline: google.maps.Polyline): number {
                const path = polyline.getPath();

                let foundMaxSpeed = 0;

                for (let i = 1; i < path.getLength(); i++) {

                    const point1 = path.getAt(i - 1);
                    const point2 = path.getAt(i);

                    const time1 = parseISO(logbookItems.value[i - 1].gpsTimestamp).getTime();
                    const time2 = parseISO(logbookItems.value[i].gpsTimestamp).getTime();

                    const speed = calculateSpeedInKnots(point1, time1, point2, time2)

                    if (speed > foundMaxSpeed) {
                        foundMaxSpeed = speed;
                        maxSpeedIndex = i;
                    }
                }
                return foundMaxSpeed;
            }

            function formatTimestamp(timestamp) {
                const date = new Date(timestamp);
                const options: Intl.DateTimeFormatOptions = {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false
                };
                return date.toLocaleString("en-US", options) + " (UTC)";
            }

            function generateRandomFileName(length = 32): string {
                const userId = profile.value.userId;
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }
                return "temp_" + userId + "_" + result + '.jpeg';
            }

            // Loop through the logbook items and create a polyline, markers and calculate the total distance, total time and average speed.
            const runLoop = () => {
                // Run the loop only if the map is loaded and the logbook items are fetched.
                if (logbookItems.value.length > 0) {

                    myGoogleMap.addListener("click", () => {
                        infoWindows.forEach(infoWindow => {
                            infoWindow.close();
                        });
                    });

                    // Create a new empty polyline.
                    poly.getPath().clear();

                    logbookItems.value.forEach((logbookItem, index) => {

                        const pos = new google.maps.LatLng(logbookItem.latitude, logbookItem.longitude);
                        // Add a new point to the Polyline based on the logbook item's latitude and longitude.

                        // Create an object representing the point with custom properties
                        const point = {
                            position: pos,
                            gpsTimestamp: logbookItem.gpsTimestamp, // Custom property: GPS timestamp
                            accuracy: logbookItem.accuracy // Custom property: Accuracy
                        };

                        poly.getPath().push(point.position);

                        if (index === 0) {
                            // Set the start marker's position to the first point in the Polyline.
                            startMarker.setPosition(pos);
                            startMarker.addListener("click", () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: `
<h3 style="text-align:center"><strong>${formatTimestamp(logbookItem.gpsTimestamp)}</strong></h3>

<p class="mb-0" style="text-align:center"><strong>Lat:</strong>&nbsp;${logbookItem.latitude}<strong>&nbsp;&nbsp;|&nbsp; Lon: </strong>${logbookItem.longitude}</p>
  `
                                });

                                // Open the info window.
                                infoWindow.open(myGoogleMap, startMarker);
                                infoWindows.push(infoWindow);
                            });
                            startMarker.setVisible(true);
                        } else if (index === logbookItems.value.length - 1) {
                            // Set the end marker's position to the last point in the Polyline.
                            endMarker.setPosition(pos);
                            endMarker.addListener("click", () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: `
<h3 style="text-align:center"><strong>${formatTimestamp(logbookItem.gpsTimestamp)}</strong></h3>

<p class="mb-0" style="text-align:center"><strong>Lat:</strong>&nbsp;${logbookItem.latitude}<strong>&nbsp;&nbsp;|&nbsp; Lon: </strong>${logbookItem.longitude}</p>
  `
                                });
                                // Open the info window.
                                infoWindow.open(myGoogleMap, endMarker);
                                infoWindows.push(infoWindow);
                            });
                            endMarker.setVisible(true);
                        } else {
                            // Create a new marker for each point in the Polyline.
                            const historyMarker = new google.maps.Marker({
                                position: pos,
                                icon: historyIcon,
                                map: myGoogleMap,
                                visible: true,
                                zIndex: 3,
                            });
                            historyMarker.addListener("click", () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: `
<h3 style="text-align:center"><strong>${formatTimestamp(logbookItem.gpsTimestamp)}</strong></h3>

<p class="mb-0" style="text-align:center"><strong>Lat:</strong>&nbsp;${logbookItem.latitude}<strong>&nbsp;&nbsp;|&nbsp; Lon: </strong>${logbookItem.longitude}</p>
  `
                                });
                                // Open the info window.
                                infoWindow.open(myGoogleMap, historyMarker);
                                infoWindows.push(infoWindow);
                            });
                        }
                    });

                    // Calculate whether the end marker is within the radius of the start marker
                    const withinRadius = isMarkerWithinRadius(startMarker, endMarker, roundTripRadius);

                    // If the end marker is within the radius of the start marker, then it is a round trip
                    if (withinRadius) {
                        // Handle case where it is a round trip, as start and end markers are in a given radius from each other
                        endMarker.setVisible(false);
                        endMarker.setPosition(startMarker.getPosition());
                        startMarker.setIcon(roundTripIcon);
                        poly.getPath().removeAt(poly.getPath().getLength() - 1);
                        poly.getPath().push(startMarker.getPosition());
                    } else {
                        // Handle case where it is not a round trip, as start and end markers are not in a given radius from each other
                        endMarker.setVisible(true);
                        startMarker.setIcon(startIcon);
                    }

                    maxSpeed.value = findMaxSpeed(poly).toFixed(2);

                    // Get the halfway point coordinates
                    const halfwayPoint = google.maps.geometry.spherical.interpolate(
                        poly.getPath().getAt(maxSpeedIndex),
                        poly.getPath().getAt(maxSpeedIndex + 1),
                        0.5
                    );

                    // Create a new marker for the halfway point.
                    const maxSpeedMarker = new google.maps.Marker({
                        position: halfwayPoint,
                        icon: maxSpeedIcon,
                        map: myGoogleMap,
                        visible: true,
                        zIndex: 5,
                    });

                    maxSpeedMarker.addListener("click", () => {
                        // Create a new info window.
                        const infoWindow = new google.maps.InfoWindow({
                            content: `
<h3 style="text-align:center"><strong>Max speed</strong></h3>

<p class="mb-0" style="text-align:center">${maxSpeed.value} <strong>kts</strong></p>
  `
                        });
                        // Open the info window.
                        infoWindow.open(myGoogleMap, maxSpeedMarker);
                        infoWindows.push(infoWindow);
                    });

                    // Create a heading marker on each segment of the polyline
                    poly.getPath().forEach((point, index) => {
                        if (index < poly.getPath().getLength() - 1) {

                            // Get the halfway point coordinates between two points in the Polyline
                            const halfwayPoint = google.maps.geometry.spherical.interpolate(
                                poly.getPath().getAt(index + 1),
                                point,
                                0.2
                            );

                            // Calculate heading between two points and set the heading marker's rotation
                            const heading = google.maps.geometry.spherical.computeHeading(
                                poly.getPath().getAt(index + 1),
                                point
                            );

                            // Create a new marker for the halfway point.
                            const headingMarker = new google.maps.Marker({
                                position: halfwayPoint,
                                map: myGoogleMap,
                                icon: {
                                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                    scale: 5,
                                    strokeColor: "#182551",
                                    strokeWeight: 2,
                                    fillColor: "#48A6AD",
                                    fillOpacity: 1,
                                    rotation: heading,
                                },
                                visible: true,
                                zIndex: 4,
                            });

                            headingMarker.addListener("click", () => {
                                // Create a new info window.
                                const infoWindow = new google.maps.InfoWindow({
                                    content: `
                                    <h3 style="text-align:center"><strong>Heading</strong></h3>

<p class="mb-0" style="text-align:center">${heading.toFixed(0)}<strong>&deg;</strong></p>
                                `,
                                });
                                // Open the info window.
                                infoWindow.open(myGoogleMap, headingMarker);
                                infoWindows.push(infoWindow);
                            });
                        }
                        console.log("Removing Google Fonts from runLoop()");
                    //    removeGoogleFontsForMaps();
                    });



                    // Create a new bounds object.
                    var bounds = new google.maps.LatLngBounds();
                    // Extend the bounds object with the polyline's path.
                    poly.getPath().forEach(function (e) { //can't do polyline.getPath()[i] because it's a MVCArray
                        bounds.extend(e);
                    })
                    // Fit the map to the bounds.
                    myGoogleMap.fitBounds(bounds);

                    let startTimestamp = logbookItems.value[logbookItems.value.length - 1].gpsTimestamp;
                    let stopTimestamp = logbookItems.value[0].gpsTimestamp;

                    const startDate = new Date(startTimestamp);
                    const endDate = new Date(stopTimestamp);

                    const startHour = startDate.getHours();
                    const startMinute = startDate.getMinutes();

                    const stopHour = endDate.getHours();
                    const stopMinute = endDate.getMinutes();

                    const startDateString = `${startHour}:${startMinute}`;
                    const endDateString = `${stopHour}:${stopMinute}`;

                    startTime.value = startDateString;
                    stopTime.value = endDateString;


                    // Calculate the total time of the trip in milliseconds and convert it to days, hours, minutes and seconds.
                    const totalTimeInMs = parseISO(stopTimestamp).getTime() - parseISO(startTimestamp).getTime();

                    // Time calculations for days, hours, minutes and seconds
                    const totalTimeInSeconds = Math.floor(totalTimeInMs / 1000);
                    const days = Math.floor(totalTimeInMs / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((totalTimeInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((totalTimeInMs % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((totalTimeInMs % (1000 * 60)) / 1000);

                    // Output the result in an element with id="demo"
                    let timestring = "";
                    timestring = days > 0 ? `${timestring}${days}d ` : "";
                    timestring = hours > 0 ? `${timestring}${hours}h ` : "";
                    timestring = minutes > 0 ? `${timestring}${minutes}m ` : "";
                    timestring = seconds > 0 ? `${timestring}${seconds}s` : "0s";

                    // Display the result
                    totalTime.value = timestring.trim();

                    // Calculate distance of the polyline
                    let distance = google.maps.geometry.spherical.computeLength(poly.getPath().getArray()) / 1852; // Convert to nautical miles

                    // Display the result
                    if (distance) {
                        totalDistance.value = distance.toFixed(2);
                    } else {
                        totalDistance.value = "0.00";
                    }

                    // Calculate average speed and display the result
                    let averageSpeedKTS = distance / (totalTimeInSeconds / 3600); // Convert to knots

                    // Display the result
                    averageSpeed.value = averageSpeedKTS.toFixed(2);

                    tripData.value = [
                        { label: 'Start Time', value: startTime.value, unit: '', icon: 'timer-play-outline' },
                        { label: 'Stop Time', value: stopTime.value, unit: '', icon: 'timer-stop-outline' },
                        { label: 'Trip Time', value: totalTime.value, unit: '', icon: 'timer-sync-outline' },
                        { label: 'Trip Distance', value: totalDistance.value, unit: 'NM', icon: 'map-marker-distance' },
                        { label: 'Average Speed', value: averageSpeed.value, unit: 'kts', icon: 'speedometer-medium' },
                        { label: 'Max Speed', value: maxSpeed.value, unit: 'kts', icon: 'speedometer' }
                    ];
                }
            }

            //const removeGoogleFontsForMaps = () => {
            //    // Find and remove Google Fonts styles injected by Google Maps
            //    const googleFontsLinks = document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"][href*="fonts.googleapis.com"]');

            //    googleFontsLinks.forEach(link => {
            //        // iterate and console log the links found

            //        console.log("Checking link:");
            //        console.log(link.href);

            //        // Check if the link does not contain the fonts you want to keep
            //        if (!link.href.includes('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap')) {

            //            console.log("Removing link:");
            //            console.log(link.href);
            //            // Remove the link from the DOM
            //            link.remove();
            //        }
            //    });
            //};
            //// Add a delay before executing the function to ensure stylesheets are loaded
            //const delayBeforeRemovingFonts = () => {
            //    setTimeout(() => {
            //        removeGoogleFontsForMaps();
            //    }, 1000); // Adjust the delay as needed
            //};

            onMounted(async () => {

                if (!isNaN(parseInt(journeyId))) {
                    journey.value = await getFavouriteJourney(parseInt(journeyId));
                }

                await profilestore.Get();
                // Load the Google Maps API and create the map, polyline and ship marker.
                googleMapApi.load().then(() => {
                    // Create a latitude and longitude object from the alarm's latitude and longitude values.
                    ship = new google.maps.LatLng(lat.value, lng.value);

                    // Create an icon for the markers.
                    const shipIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-device.svg',
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    startIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-start.svg',
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    endIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-stop.svg',
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    roundTripIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-round-trip.svg',
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    maxSpeedIcon = {
                        url: 'https://dsspoc.azurewebsites.net/img/icons/max-speed.svg',
                        scaledSize: new google.maps.Size(40, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(20, 20)
                    };

                    historyIcon = {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 3,
                        fillColor: "#a6a6a6",
                        fillOpacity: 1,
                        strokeColor: "#a6a6a6",
                        strokeOpacity: 1,
                    };

                    // Create the map.
                    myGoogleMap = new google.maps.Map(map.value, {
                        center: ship,
                        mapTypeId: "satellite",
                        zoom: 16,
                        disableDefaultUI: true,
                        zoomControl: false,
                        backgroundColor: "#000000",
                        mapTypeControl: true,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DEFAULT,
                            mapTypeIds: ["roadmap", "satellite"],
                        },
                        fullscreenControl: false
                    });

                    // Create the ship marker.
                    shipMarker = new google.maps.Marker({
                        position: ship,
                        map: myGoogleMap,
                        icon: shipIcon,
                        visible: false,
                    });

                    // Create the start marker.
                    startMarker = new google.maps.Marker({
                        position: ship,
                        map: myGoogleMap,
                        icon: startIcon,
                        visible: false,
                        zIndex: 6,
                    });

                    // Create the end marker.
                    endMarker = new google.maps.Marker({
                        position: ship,
                        map: myGoogleMap,
                        icon: endIcon,
                        visible: false,
                        zIndex: 6,
                    });

                    // Create the polyline.
                    poly = new google.maps.Polyline({
                        //strokeColor: "#a6a6a6",
                        strokeColor: "#48A6AD",
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        zIndex: 2,
                    });

                    poly.setMap(myGoogleMap); // Add the polyline to the map

                    //removeGoogleFontsForMaps();

                    onMountedFinished = true; // Set onMountedFinished to true when the map is loaded

                    if (logbookItemsFetched) {
                        runLoop(); // Execute runLoop() if both conditions are met
                        console.log("Removing Google Fonts from onMounted()");
                        //delayBeforeRemovingFonts();
                    }

                });
            });

            // Watch for changes in the logbookItems array, and execute runLoop() when the array is populated, and the map is loaded.
            watch(logbookItems, () => {
                if (!logbookItemsFetched) {
                    logbookItemsFetched = true;
                    if (onMountedFinished) {
                        runLoop(); // Execute runLoop() if both conditions are met
                        console.log("Removing Google Fonts from watch()");
                        //delayBeforeRemovingFonts();
                    }
                }
            });

            return {
                formattedDate,
                map,
                goBack,
                tripData,
                carouselModel,
                showCarousel,
                menuItems,
                captureAndShareBase,
                getIconPath,
                showLoadingDialog,
                showShareDialog,
                shareNow,
                showHint,
                hintItems,
                showExtras,
                isFavourite,
                journeyId,
                showEditNicknameDialog,
                journey,
                updateJourney,
                saveJourney,
                hasGalleryAccess,
                isCaptain,
                showSaveDialog,
                goToGallery,
                nickname,
                description,
                deleteJourney,
                showDeleteDialog,
                captureLog,
                shareImageUrl,
            };
        },
    });
